// @flow

import { SimpleEntity } from '../abstract/SimpleEntity';
import type { EntityFieldCollection } from '../types';
import Bill from './Bill';

class RewardTransactionBillRecord implements SimpleEntity {
    static fields: EntityFieldCollection = {
        bill: {
            displayName: 'Bill',
            recordName: 'bill_id',
            dataType: {
                primitive: 'str',
                isArray: false,
                extraData: {
                    model: () => Bill,
                    maxValues: 1,
                },
            },
            isOptional: false,
        },
        billAmount: {
            displayName: 'Bill Amount',
            recordName: 'bill_amount',
            dataType: {
                primitive: 'amt',
                isArray: false,
                extraData: null,
            },
            isOptional: false,
        },
    };

    constructor(record: any) {
        this.record = record;
    }
}

export default RewardTransactionBillRecord;
